import React from 'react';
import {Checkbox} from 'antd';
import {ChannelsContainer, PublishingBanner} from './pressReleaseStyles';
import {useStore} from '@/store/root-store';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHourglassStart} from '@fortawesome/pro-duotone-svg-icons';

const CloudStackSites = ({record, updateStackProviders, publishing, updateCloudStackProviders, selectedDistributionChannels}) => {
  const {ottoV2Store: {
    cloudStackProviders,
  },
  } = useStore('');

  return (
    <ChannelsContainer style={{marginBottom: '23px'}}>
      <div style={{padding: '0px 25px'}}>
        {publishing ? <PublishingBanner>
          <FontAwesomeIcon icon={faHourglassStart} color='#FF8536' />
          Content is being published to the Distribution Channels.
        </PublishingBanner> : ''}
        <div className='checkboxes-heading' style={{marginTop: '19px'}}>Select Clouds Stack Sites to Publish:</div>
        <div className='sites-list' style={{maxWidth: '100%', display: 'flex', flexWrap: 'wrap'}}>
          {cloudStackProviders?.map(item => (
            <div key={item?.id} className='data-row' style={{width: '319px', marginBottom: '9px'}}>
              <div className='checkbox-row' style={{display: 'flex', alignItems: 'center', gap: '9px'}}>
                <Checkbox
                  onChange={e => {
                    updateStackProviders({displayName: item?.name, id: item?.id, creditsCost: 15}, e.target.checked, record?.id);
                    updateCloudStackProviders(record?.id, item?.id, true, item?.name);
                  }}
                  checked={selectedDistributionChannels?.some(channel => channel?.channelId == item?.id)}
                />
                <div style={{display: 'flex', alignItems: 'center', gap: 6}}>
                  <img src={`/img/icon/${item?.name?.toLowerCase()}.svg`} alt='' style={{cursor: 'pointer', width: 24, height: 24, verticalAlign: 'bottom'}}/>
                  <div>{item?.name}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </ChannelsContainer>
  );
};

export default CloudStackSites;
